enum ResponseStatus {
  OPEN = 0,
  ACCEPTED = 1,
  REJECTED = 2,
}

export default ResponseStatus;
